var map = {
	"./01-appStore.svg": 23551,
	"./02-googlePlay.svg": 15210,
	"./03-Huawei-EN.svg": 1495,
	"Common/Assets/Icons/AppStore/01-appStore.svg": 23551,
	"Common/Assets/Icons/AppStore/02-googlePlay.svg": 15210,
	"Common/Assets/Icons/AppStore/03-Huawei-EN.svg": 1495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55226;